import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Buffer } from 'buffer';
import process from 'process';
import 'maplibre-gl/dist/maplibre-gl.css';


// Import only from text-encoding (not util!)
import { TextEncoder, TextDecoder } from 'text-encoding';
window.global = window;
window.process = process;
window.Buffer = Buffer;

if (typeof window.TextEncoder === "undefined") {
  window.TextEncoder = TextEncoder;
}
if (typeof window.TextDecoder === "undefined") {
  window.TextDecoder = TextDecoder;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
